// extracted by mini-css-extract-plugin
export const servicesGrid = "servicesCategory-module--servicesGrid--3pxoc";
export const serviceCategory = "servicesCategory-module--serviceCategory--WkYXV";